module.exports = __webpack_public_path__ + "img/banner-6.8e3bf2b9.jpg";